<template>
  <footer class="footer">
    <b-container>
      <b-row>
        <b-col xl="7" lg="8" class="pr-5">
          <div class="d-flex justify-content-between">
          <ul v-if="!!categoriesList[0]">
            <li><h4 class="mb-1"> {{ $t("nav.whatINeedToKnow") }} </h4></li>
            <li class="footer__item"
              v-for="article in sortedArticles" :key="article.id">
              <router-link class="footer__item"
                :to="{ path: `/need_to_know/${article.id}` }"
                v-scroll-to="'#scrollToOnLoad'">
                {{ article.title }}
              </router-link>
            </li>
          </ul>
        <!-- </b-col>
        <b-col cols="2"> -->
          <ul>
            <li class="footer__item"><h4>
              Experiment
            </h4></li>
            <li class="footer__item">
              <router-link :to="{ name: 'login' }" v-scroll-to="'#scrollToOnLoad'">
              {{ $t("nav.logIn") }}</router-link>
            </li>
            <li class="footer__item">
              <router-link :to="{ name: 'prev_results' }"
                v-scroll-to="'#scrollToOnLoad'"
                v-if="isUserLoggedIn">
                {{ $t("nav.previouseResults") }}
              </router-link>
            </li>
            <li class="footer__item">
              <router-link :to="{ name: 'building_blocks' }"
                v-scroll-to="'#scrollToOnLoad'"
                v-if="isUserLoggedIn">
                {{ $t("nav.chooseMyBuldingBlocks") }}
              </router-link>
            </li>
            <li class="footer__item">
             <router-link :to="{ name: 'report_my_results' }"
                v-scroll-to="'#scrollToOnLoad'"
                v-if="isUserLoggedIn">
                {{ $t("nav.reportResults") }}</router-link>
            </li>
            <li class="footer__item">
              <router-link :to="{ name: 'students_list' }"
                v-scroll-to="'#scrollToOnLoad'"
                v-if="isUserLoggedIn && userRole === 'teacher'">
                {{ $t("nav.studentsList") }}</router-link>
            </li>
            <li class="footer__item">
              <router-link :to="{ name: 'support' }" v-scroll-to="'#scrollToOnLoad'">
              {{ $t("nav.technicalSupport") }}</router-link>
            </li>
          </ul>
        <!-- </b-col>
        <b-col cols="2"> -->
          <ul v-if="!!categoriesList[1]">
            <li class="footer__item"><h4>{{ $t('nav.iLoveScience') }}</h4></li>
            <li class="footer__item">
              <router-link :to="{ name: 'science_in_school'}" v-scroll-to="'#scrollToOnLoad'">
              {{ $t("nav.scienceInSchool") }}</router-link>
            </li>
            <li class="footer__item"
              v-for="article in categoriesList[1].articles"
              :key="article.id">
              <router-link :to="{ path: `/i_love_science/${article.id}`}"
              v-scroll-to="'#scrollToOnLoad'">
              {{ article.title }}
              </router-link>
            </li>
            <li class="footer__item">
              <router-link :to="{ name: 'careers'}" v-scroll-to="'#scrollToOnLoad'">
              {{ $t("nav.careersInScience") }}</router-link>
            </li>
            <li class="footer__item">
              <router-link :to="{ name: 'ask_a_scientist'}" v-scroll-to="'#scrollToOnLoad'">
              {{ $t("nav.askAScientist") }}</router-link>
            </li>
            <li class="footer__item">
              <router-link :to="{ name: 'learn_more'}" v-scroll-to="'#scrollToOnLoad'">
              {{ $t("nav.whereCanILearnMore") }}</router-link>
            </li>
          </ul>
          </div>
        </b-col>
        <b-col lg="4" offset-xl="1" class="d-flex justify-content-end ">
          <a class="footer__ico" href="https://www.facebook.com/makeamolecule/" target="_blank"><i class="fab fa-facebook-f fa-2x"></i></a>
          <a class="footer__ico" href="https://www.instagram.com/makeamolecule/" target="_blank"><i class="fab fa-instagram fa-2x"></i></a>
          <a class="footer__ico" href="https://twitter.com/MakeAMolecule" target="_blank"><i class="fab fa-twitter fa-2x"></i></a>
          <div class="d-flex flex-column ">
            <h4>{{ $t("nav.contactUs") }}</h4>
            <a class="footer__item" href="mailito:hello@makeamolecule.com">
              hello@makeamolecule.com</a>
            <a class="footer__item" href="tel:+41446332103">+41 44 633 21 03</a>
          </div>
        </b-col>
      </b-row>
      </b-container>
      <b-container class="container--wide">
      <b-row class="mt-5">
        <b-col cols="3">
          <a href="#"><img src="../../assets/ethz-logo.svg" alt=""></a>
        </b-col>
        <b-col cols="3" offset="6">
          <a href="#"><img src="../../assets/logo-footer.svg" alt=""></a>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-center">
          <span class="footer__copyright">
            Copyright &copy; 2017 Agora.com, Inc. All rights reserved.
          </span>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
import auth from '@/api/v1/auth';
import categories from '@/api/v1/categories';

export default {
  data() {
    return {
      categoriesList: [],
      isUserLoggedIn: auth.user.authenticated,
      userRole: auth.user.user_type,
    };
  },
  computed: {
    sortedArticles() {
      return this.categoriesList[0].articles.concat().sort((a, b) => a.position - b.position);
    },
  },
  methods: {
    getCategories() {
      const succ = (response) => {
        this.categoriesList = response.data.categories;
      };
      categories.index(succ);
    },
  },
  created() {
    this.getCategories();
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/helpers/_variables.scss';
@import '../../styles/helpers/_include-media.scss';

.footer {
  background-color: $color--navy-blue;
  padding-top: 57px;
  &__item {
    font-size: 16px;
    line-height: 21px;
  }
  &__ico {
    margin-right: 45px;
    @include media('<xl') {
      margin-right: 20px;
    }
  }
  &__copyright {
    font-size: 13px;
    text-align: center;
    color: $color--white;
    border-top: 3px solid $color--white;
    width: 100%;
    margin-top: 10px;
    padding: 17px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer/FooterDesktop.vue